import React from 'react'
import {isRouteErrorResponse, Link, useRouteError} from 'react-router-dom'
import {Button, Container, Paper, Stack, Typography} from '@mui/material'

export default function ErrorPage() {
  const error = useRouteError()
  return <Container id="error-page" maxWidth="sm" sx={{py: 6}}>
    <Paper sx={{p: {xs: 3, sm: 4}}}><Stack spacing={2}>
      <Typography variant="h3" component="h1">Oops!</Typography>
      <Typography>Sorry, an unexpected error has occurred.</Typography>
      <Typography color="text.secondary" sx={{overflowWrap: 'anywhere'}}>{isRouteErrorResponse(error) ? error.statusText : error instanceof Error ? error.message : 'Unknown error'}</Typography>
      <Button component={Link} to="/" variant="outlined" sx={{alignSelf: 'flex-start'}}>Return to timer</Button>
    </Stack></Paper>
  </Container>
}
